import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type ImageUploadApiResponse } from '../services/imageUploadService'

export interface ImageUploadState {
  isLoading: boolean
  error: string | undefined
  data: ImageUploadApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: ImageUploadState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const imageUploadSliceSite = createSlice({
  name: 'ImageUploadSlice',
  initialState,
  reducers: {
    ImageUploadLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    ImageUploadUpdateAction: (state, action: PayloadAction<{ data: ImageUploadApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    ImageUploadErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    ImageUploadReset: () => initialState
  }
})

export const {
  ImageUploadLoadingAction,
  ImageUploadUpdateAction,
  ImageUploadErrorAction,
  ImageUploadReset
} = imageUploadSliceSite.actions

export default imageUploadSliceSite.reducer
